<div class="approval-shimmer">
    <!-- LOAN AMOUNT -->
    <div class="approval-title">
        <span class="skeleton shimmer-title"></span>
        <span class="skeleton shimmer-amount"></span>
    </div>

    <!-- SLIDER -->
    <div class="shimmer-slider-track">
        <span class="shimmer-tick skeleton" *ngFor="let i of [].constructor(25)"></span>
    </div>

    <div class="shimmer-line skeleton"></div>

    <!-- TENURE -->
    <div class="tenure-title">
        <span class="skeleton shimmer-title"></span>
        <span class="skeleton shimmer-tenure"></span>
    </div>

    <!-- EMI -->
    <div class="emi-title">
        <span class="skeleton shimmer-title"></span>
        <span class="skeleton shimmer-emi"></span>
    </div>
</div>

<div class="skeleton-main">
    <div class="skeleton-left">
        <div
            *ngFor="let i of [].constructor(skeletonCount); let index = index"
            class="skeleton h15 mb10"
            [ngClass]="'w' + skeletonWidthsLeft[index % skeletonWidthsLeft.length]"
        ></div>
    </div>
    <div class="skeleton-right">
        <div
            *ngFor="let i of [].constructor(skeletonCount); let index = index"
            class="skeleton h15 mb10"
            [ngClass]="'w' + skeletonWidthsRight[index % skeletonWidthsRight.length]"
        ></div>
    </div>
</div>
